
class HeaderDashboard {

    constructor() {
        this._init();
    }


    private _init(): void {
        const menu = document.querySelector<HTMLElement>('[data-header-dashboard-menu]');
        const button = document.querySelector<HTMLElement>('[data-header-dashboard-button]');
        const overlay = document.querySelector<HTMLElement>('[data-header-dashboard-overlay]');

        if (!button || !overlay || !menu) return;

        const closeMenu = () => {
            menu.classList.remove('active');
            button.classList.remove('active');
            button.setAttribute('aria-expanded', 'false');
            menu.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
        };

        button.addEventListener('click', () => {
            button.classList.toggle('active');
            const isActive = menu.classList.toggle('active');

            button.setAttribute('aria-expanded', String(isActive));
            menu.setAttribute('aria-hidden', String(!isActive));
            document.body.style.overflow = isActive ? 'hidden' : '';
        });

        overlay.addEventListener('click', closeMenu);
    }

}

export const headerDashboard = new HeaderDashboard();
